import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Button, Form, Icon } from 'semantic-ui-react'
import _find from 'lodash/find';
import general from '../../../modulos/general';

//utils
import queries from '../../../utils/queries'

import TitDer from '../../../components/funcionales/titder';
import EstaSeguro from '../../../components/funcionales/estaseg7btn';
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


// import general from '../../modulos/general';

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  let coti=""
  if(props.elemento.numCoti){
    coti = props.elemento.numSolic + " ==> " + props.elemento.numCoti + " ==> ORDEN DE COMPRA " + props.elemento.numOrdenCompra + " ==> " + props.elemento.descrProveed 
  }

  return (
    <option style={props.styles.input} value={props.elemento.numSolic}>{coti}</option>
  )
};
 
const ListaSol = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="numSolic" id="miLista" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar orden de compra...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetallePl = ({elemento, handleClickidLista, idListaP}) => {
  let urlSlcm = 'https://montserratslcm.com/api/cotizaciones/'

  return( 
    <tr className=''>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fechaCreate.substr(0, 10)}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fechaRta?elemento.fechaRta.substr(0, 10):''}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numSolic}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numCoti}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numOrdenCompra}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrProveed}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorUniCoti?new Intl.NumberFormat('de-DE').format(elemento.valorUniCoti):0}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.cantidadRecibida?new Intl.NumberFormat('de-DE').format(elemento.cantidadRecibida):0}</td>
       <td className='left aligned' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          // href={'images/cotizaciones/' + elemento.archivoEnviado}
          href={urlSlcm + elemento.archivoEnviado}
            target="_blank">
          {elemento.archivoEnviado}
        </a>
      </td>
      <td className='' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          // href={'images/cotizaciones/' + elemento.archivoRecibido}
          href={urlSlcm + elemento.archivoRecibido}
            target="_blank">
          {elemento.archivoRecibido}
        </a>
      </td>
    </tr>
  )
};
// href="#" onclick="window.location.href ='file:///./slcm-client/public/images/documentos/' + elemento.nombreDoc"

const ListaPl = ({list, handleClickidLista, idListaP}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} handleClickidLista={handleClickidLista}
        key={i} idListaP={idListaP}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const DetalleNivelLista = ({elementoI, handleClickidListaI, idListaI}) => {
  return(
    <tr className=''>
    {/* <tr className=''> */}
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.cantidadCoti}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.cantidadAprob}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.cantidadRecibida}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.descrUnidad}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.descrProducto}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              // color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.valorUniCoti}</td>
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{new Intl.NumberFormat('de-DE').format(elementoI.valorUniCoti)}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.porcDcto}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              // color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.cantidadRecibida * (elementoI.valorUniCoti * (1 - (elementoI.porcDcto/100)))}</td>
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{new Intl.NumberFormat('de-DE').format(elementoI.cantidadRecibida * (elementoI.valorUniCoti * (1 - (elementoI.porcDcto/100))))}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}} onClick={(ev)=>handleClickidListaI(ev, elementoI)}>{elementoI.porcIVA}</td>
    
    </tr>
  )
};
const Lista = ({listI, handleClickidListaI, idListaI}) => {
  // console.log(listI)
  const nivel1Detalle = listI.map((elementoI, i) => <DetalleNivelLista elementoI={elementoI} handleClickidListaI={handleClickidListaI}
        key={i} idListaI={idListaI} 
        />);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};



class AdminOrdenCompraPro2 extends React.Component {
  state={idListaP: {}, idListaI: {}, procBtn: 0, permiteBtn1: true, permiteBtn2: true, confirmaAct: false, 
  open: false, argsDocum: {}, argsDocumI: {}, lista: [], lista4: [], errorAdd: [],
  argsQuery: `{"$unwind": "$itemsCoti"},
  {$project: {_id: {$concat: ['$numCoti', '$numSolic', '$itemsCoti.descrProducto']}, numCoti: 1, numSolic: 1,
      tipoProducto: '$itemsCoti.tipoProducto', 
      descrProducto: '$itemsCoti.descrProducto', 
      cantidadCoti: '$itemsCoti.cantidadCoti', 
      cantidadAprob: '$itemsCoti.cantidadAprob', 
      cantidadRecibida: '$itemsCoti.cantidadRecibida', 
      valorUniCoti: '$itemsCoti.valorUniCoti', 
      porcDcto: '$itemsCoti.porcDcto',
      porcIVA: '$itemsCoti.porcIVA',
      moneda: '$itemsCoti.moneda',
      descrUnidad: '$itemsCoti.descrUnidad'}},
  {$match: {cantidadAprob: {$gt: 0}}}, {$sort: {descrProducto: 1}}`,
  argsQuery1: `{"$unwind": "$itemsCoti"},
  {$project: {_id: 1, fechaCreate: 1, numCoti: 1, numSolic: 1, numOrdenCompra: 1, fechaRta: 1, 
    descrProveed: 1, tipo: 1, tipoCoti: 1, estadoOC: 1, observaciones: 1, archivoEnviado: 1, archivoRecibido: 1, 
    cedula: 1, nombreContacto: 1, ciudad: 1, direccion: 1, telefono: 1, email: 1, observacionesOC: 1, 
    cantidadRecibida: '$itemsCoti.cantidadRecibida', valorUniCoti: '$itemsCoti.valorUniCoti', moneda: '$itemsCoti.moneda', 
    cantidadAprob: '$itemsCoti.cantidadAprob', porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto'}},
  {$match: {cantidadAprob: {$gt: 0}}},
  {$project: {_id: 1, fechaCreate: 1, numCoti: 1, numSolic: 1, numOrdenCompra: 1, fechaRta: 1, 
    descrProveed: 1, tipo: 1, tipoCoti: 1, estadoOC: 1, observaciones: 1, archivoEnviado: 1, archivoRecibido: 1, 
    cedula: 1, nombreContacto: 1, ciudad: 1, direccion: 1, telefono: 1, email: 1, observacionesOC: 1, moneda: 1,
    valorItem: {
      $let: {
          vars: {cantidadRecibida: {$toInt: '$cantidadRecibida'}, valorUniCoti: '$valorUniCoti', porcDcto: {$toDouble: '$porcDcto'}},
          in: { $multiply: [ "$$cantidadRecibida", {$multiply: ["$$valorUniCoti", {$add: [1, {$divide: [ "$$porcDcto", -100 ]} ]} ]} ] }
      }
    },
    valorItemIVA: {
      $let: {
        vars: {cantidadRecibida: {$toInt: '$cantidadRecibida'}, valorUniCoti: '$valorUniCoti', porcIVA: {$toInt: '$porcIVA'}, porcDcto: {$toDouble: '$porcDcto'}},
        in: { $multiply: [ "$$cantidadRecibida", {$multiply: [{$multiply: ["$$valorUniCoti", {$add: [1, {$divide: [ "$$porcDcto", -100 ]} ]} ]}, {$add: [1, {$divide: [ "$$porcIVA", 100 ]} ]} ]} ]}
      }
    }
  }},
  {$group: {_id: {_id: '$_id', fechaCreate: '$fechaCreate', numCoti: '$numCoti', numSolic: '$numSolic', 
  numOrdenCompra: '$numOrdenCompra', fechaRta: '$fechaRta', 
  descrProveed: '$descrProveed', tipo: '$tipo', tipoCoti: '$tipoCoti', estadoOC: '$estadoOC', 
  observaciones: '$observaciones', archivoEnviado: '$archivoEnviado', archivoRecibido: '$archivoRecibido', 
  cedula: '$cedula', nombreContacto: '$nombreContacto', ciudad: '$ciudad', observacionesOC: '$observacionesOC', 
  direccion: '$direccion', telefono: '$telefono', email: '$email', moneda: '$moneda'},
  valorTotal: {$sum: '$valorItem'}, valorTotalIVA: {$sum: '$valorItemIVA'}
  }},
  {$project: {_id: '$_id._id', fechaCreate: '$_id.fechaCreate', numCoti: '$_id.numCoti', numSolic: '$_id.numSolic', 
  numOrdenCompra: '$_id.numOrdenCompra', fechaRta: '$_id.fechaRta', observacionesOC: '$_id.observacionesOC', 
  descrProveed: '$_id.descrProveed', tipo: '$_id.tipo', tipoCoti: '$_id.tipoCoti', estadoOC: '$_id.estadoOC', 
  observaciones: '$_id.observaciones', archivoEnviado: '$_id.archivoEnviado', archivoRecibido: '$_id.archivoRecibido', 
  cedula: '$_id.cedula', nombreContacto: '$_id.nombreContacto', ciudad: '$_id.ciudad', 
  direccion: '$_id.direccion', telefono: '$_id.telefono', email: '$_id.email', moneda: '$_id.moneda',
        valorUniCoti: '$valorTotal', cantidadRecibida: '$valorTotalIVA'
    }}, {$sort: {numCoti: -1}}`
  }

  crudBD = async (operacionCRUD, args, i)=>{
    //ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

    //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    //ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }

    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  handleClickidLista = async (ev, idListaP)=>{
    ev.preventDefault()
    let argsBuscar=""
    argsBuscar += `'numCoti': '${idListaP.numCoti}', 'numSolic': '${idListaP.numSolic}'`
    let argsBuscarIt = {}
    argsBuscarIt = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}]`}
    console.log(argsBuscarIt)
    let {data} = await this.props.allCotizacionRtes1Proc.refetch(argsBuscarIt)
    this.setState({lista4: await data.allCotizacionRtes})
    this.setState({idListaP: idListaP})
    console.log(this.state.idListaP)
  }
  handleClickidListaI = async (ev, idListaI)=>{
    ev.preventDefault()
    console.log(idListaI)

    this.setState({idListaI: idListaI})
    let argsDocumI = this.state.argsDocumI
    argsDocumI['cantidadRecibida'] = idListaI.cantidadRecibida
    this.setState(argsDocumI)
  } 
  idListaI = async (ev, idListaI)=>{
    console.log(idListaI)
    this.setState({idListaI: idListaI})
    // this.setState({productoI: idLista.descrProducto})
    // console.log(this.state.productoI)
    ev.preventDefault()
  };

  handleChange = async(ev)=>{
    const argsDocum = this.state.argsDocum
    const argsDocumI = this.state.argsDocumI
    argsDocum[ev.target.name] = ev.target.value
    this.setState({argsDocum});
    this.setState({idListaP: {}});
    let argsBuscar = `'tipoCoti': 'Proveedor', 'estadoOC': 'Creada'`
    argsBuscar += `, 'numSolic': '${argsDocum.numSolic}'`
    let argsBuscCoti = ""
    argsBuscCoti = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
    console.log(argsBuscCoti)

    if(2>1){
      if(this.props.allCotizacionRtes.allCotizacionRtes){
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscCoti)
      let lista = await data.allCotizacionRtes
      this.setState({lista})
      }
    }

    this.setState({argsDocumI});
    this.setState({idListaI: {}});    
    argsBuscar = `'tipoCoti': 'Proveedor', 'estadoOC': 'Creada'`
    let argsBuscarIt = {}
    argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
    let {data} = await this.props.allCotizacionRtes1Proc.refetch(argsBuscarIt)
    this.setState({lista4: await data.allCotizacionRtes})
  }

  handleChangeI = async(ev, numCoti, descrProducto)=>{
    const argsDocumI = this.state.argsDocumI
    argsDocumI[ev.target.name] = ev.target.value
    argsDocumI['numCoti'] = numCoti
    argsDocumI['descrProducto'] = descrProducto

    this.setState({argsDocumI});
    console.log(this.state.argsDocumI)
  }

  handleQuestionUpdDel = async (ev, btn) => {
    console.log(btn, this.state.confirmaAct, this.state.procBtn)
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      console.log(btn)
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
    }else{
      console.log(btn)
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="Si"){
      console.log(btn)
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
      console.log(this.state.permiteBtn1, this.state.permiteBtn2)
      const myBtn = document.getElementById("btnUpdDel");
      console.log(myBtn)
      myBtn.click()
    }
  }


  componentDidUpdate(prevProps, prevState){
    if(this.props.list!==prevProps.list){
      this.setState({idListaP: []})
      this.setState({permiteBtn1: true, open: false, confirmaAct: false})
    }
  }

  // componentDidUpdate = async (prevState) => {
  //   if(this.props.argsBuscCoti!==this.state.argsBuscCoti){
  //     let argsBuscar = `'estadoCoti': 'Enviada'`
  //     argsBuscar += `, 'descrEmpresa': /${this.state.argsDocum.descrEmpresa}/i`

  //     if(this.props.argsBuscCoti.numCoti){
  //       argsBuscar += `, 'numCoti': /${this.props.argsBuscCoti.numCoti}/i`
  //     }
  //     let argsBuscCoti = ""
  //     argsBuscCoti = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
  //     // argsBuscCoti = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {fechaEnvio: -1}}, {$limit: 100}]`}

  //     this.props.allCotizacionRtes.refetch(argsBuscCoti)
  //     this.setState({argsBuscCoti: this.props.argsBuscCoti})
  //   }
  // }

  handleImpPdf = async (ev, idListaP, nomUsuarioUA)=>{
    console.log(nomUsuarioUA)
let nomUsuario = nomUsuarioUA
    let list1 = idListaP
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let fechaHoy = fechaHoraHoy.substr(0, 10)

      let posic = 0

        document.body.style.cursor = 'wait'
        let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
        // let widthDoc = (doc.internal.pageSize.width)
        let widthDoc = 180
        let heightDoc = (doc.internal.pageSize.height)
        let heightDisponible=heightDoc

        let empresa = {rutaLogo: "",
        empresaRazonSocial: "",
        empresaNit: "",
        empresaWeb: "",
        empresaDir1: "",
        empresaTel1: "",
        empresaCel1: "",
        empresaCiudad1: "",
        empresaDir2: "",
        empresaTel2: "",
        empresaCel2: "",
        empresaCiudad2: "",
        empresaBanco1: "",
        empresaCuenta1: "",
        empresaBanco2: "",
        empresaCuenta2: "",
        empresaPresentacion: "",
        empresaNombreFirma: "",
        empresaCargoFirma: "",
        empresaNombreFirma2: list1.nombreUsuario?list1.nombreUsuario:"",
        empresaCargoFirma2: list1.ciudad?list1.ciudad:"",
        empresaMailFirma: list1.email?list1.email:"",
        empresaCelFirma: list1.telefono?list1.telefono:"",
        empresaWeb: ""}
        if(this.props.getParametro.getParametro){
          empresa.empresaRazonSocial = this.props.getParametro.getParametro.empresaRazonSocial
          empresa.rutaLogo = this.props.getParametro.getParametro.rutaLogo
          empresa.empresaNit = this.props.getParametro.getParametro.empresaNit
          empresa.empresaWeb = this.props.getParametro.getParametro.empresaWeb
          empresa.empresaDir1 = this.props.getParametro.getParametro.empresaDir1
          empresa.empresaTel1 = this.props.getParametro.getParametro.empresaTel1
          empresa.empresaCel1 = this.props.getParametro.getParametro.empresaCel1
          empresa.empresaCiudad1 = this.props.getParametro.getParametro.empresaCiudad1
          empresa.empresaDir2 = this.props.getParametro.getParametro.empresaDir2
          empresa.empresaTel2 = this.props.getParametro.getParametro.empresaTel2
          empresa.empresaCel2 = this.props.getParametro.getParametro.empresaCel2
          empresa.empresaCiudad2 = this.props.getParametro.getParametro.empresaCiudad2
          empresa.empresaBanco1 = this.props.getParametro.getParametro.empresaBanco1
          empresa.empresaCuenta1 = this.props.getParametro.getParametro.empresaCuenta1
          empresa.empresaBanco2 = this.props.getParametro.getParametro.empresaBanco2
          empresa.empresaCuenta2 = this.props.getParametro.getParametro.empresaCuenta2
          empresa.empresaPresentacion = this.props.getParametro.getParametro.empresaPresentacion
          empresa.empresaNombreFirma = this.props.getParametro.getParametro.empresaNombreFirma
          empresa.empresaCargoFirma = this.props.getParametro.getParametro.empresaCargoFirma
          // empresa.empresaMailFirma = empresaMailFirma
          // empresa.empresaCelFirma = empresaCelFirma
          empresa.empresaWeb = this.props.getParametro.getParametro.empresaWeb
        }
        doc.setPage()

        let columnas = ["", "", "", ""];
        let datos = [
          ["FECHA DE ELABORACION", fechaHoy, "CODIGO DE ORDEN DE COMPRA", "LCM-E-OC-" + list1.numOrdenCompra]
        ];
  
        doc.autoTable(columnas,datos,{
          margin: 20,
          startY: 40,
          rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
          styles: {
            fontSize: 9,
            lineColor: "black",
            lineWidth: 0.1,
            valign: "center",
          },
          headStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            valign: "top",
            cellPadding: 1,
            fontStyle: "bold",
            fontSize: 9
          },
          bodyStyles: {
            fillColor: "white",
            textColor: "black",
            halign: "center",
            valign: "top",
            cellPadding: 0.5,
            // minCellHeight: 1.8
          },
          columnStyles: {
            0: {cellWidth: 60},
            1: {cellWidth: 25},
            2: {cellWidth: 60},
            3: {cellWidth: 25}
          }
        })

        columnas = [""];
        datos = [
          ["INFORMACION PROVEEDOR"],
        ];
  
        doc.autoTable(columnas,datos,{
          margin: 20,
          startY: 44.7,
          styles: {
            fontSize: 9,
            lineColor: "black",
            lineWidth: 0.1,
            valign: "center",
          },
          bodyStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            valign: "top",
            // cellPadding: 1,
            fontStyle: "bold",
            fontSize: 9
          },
          columnStyles: {
            0: {cellWidth: 171}
          }
        })

        columnas = ["", "", "", ""];
        datos = [
          ["EMPRESA", list1.descrProveed, "NIT", list1.cedula],
          ["DIRECCION", list1.direccion, "TELEFONO", list1.telefono],
          ["CONTACTO", list1.nombreContacto, "CIUDAD", list1.ciudad],
          ["EMAIL", list1.email, "COTIZACION", list1.numCoti]
        ];
  
        doc.autoTable(columnas,datos,{
          margin: 20,
          startY: 52,
          rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
          styles: {
            fontSize: 9,
            lineColor: "black",
            lineWidth: 0.1,
            valign: "center",
          },
          bodyStyles: {
            fillColor: "white",
            textColor: "black",
            halign: "center",
            valign: "top",
            cellPadding: 0.5,
            // minCellHeight: 1.8
          },
          columnStyles: {
            0: {cellWidth: 25},
            1: {cellWidth: 95},
            2: {cellWidth: 25},
            3: {cellWidth: 25}
          }
        })

        columnas = [""];
        datos = [
          ["DESCRIPCION ORDEN DE COMPRA"],
        ];
  
        doc.autoTable(columnas,datos,{
          margin: 20,
          startY: 75,
          styles: {
            fontSize: 9,
            lineColor: "black",
            lineWidth: 0.1,
            valign: "center",
          },
          bodyStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            valign: "top",
            // cellPadding: 1,
            fontStyle: "bold",
            fontSize: 9
          },
          columnStyles: {
            0: {cellWidth: 171}
          }
        })
  
        let argsBuscar=""
        argsBuscar += `'numCoti': '${idListaP.numCoti}'`
        let argsBuscarIt = {}
        argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
        console.log(argsBuscarIt)
        let {data} = await this.props.allCotizacionRtes2.refetch(argsBuscarIt)
        let lista4 = []
        // console.log(data.allCotizacionRtes)
      if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
        lista4 = await data.allCotizacionRtes
      }
        let columnasCoti = ["No.", "Descripción", "Cant.", "Unidad", "Vlr Unitario", "Vlr total"];
  
        let tablaCoti = []
        let totalCoti = 0, totalIVA = 0, subTotal = 0, numLineas = 0
        posic = 82
        heightDisponible=heightDoc-25
        let lineasProd = 0
        let lineasUni = 0
        let argsUpd = []
        let subtot = ''
        let tot = ''

        lista4.forEach((elemento1, iii) => {
          numLineas = lista4.length
          if(elemento1.moneda==='Dolares'){
            subtot="Subtotal US$"
            tot="Total US$"
          }
          if(elemento1.moneda==='Euros'){
            subtot="Subtotal EU$"
            tot="Total EU$"
          }
          if(elemento1.moneda==='Pesos'){
            subtot="Subtotal $"
            tot="Total $"
          }
          argsUpd.push(iii+1)

          let parrafoProd = elemento1.descrProducto.split("\n")
          let heightLineaItem=0
          let parrafoUni = elemento1.descrUnidad.split("\n")

          parrafoProd.forEach((textoProd, ii) => {   
            lineasProd = doc.splitTextToSize(textoProd, 100)
            lineasUni = doc.splitTextToSize(parrafoUni, 40)
            if(textoProd){
              if(lineasProd.length===1){
                if(lineasUni.length===1){
                  posic+=5
                  heightLineaItem=5
                }else{
                  posic+=5*lineasUni.length
                  heightLineaItem=(5*lineasUni.length)
                }            
              }else{
                posic+=5*lineasProd.length
                heightLineaItem=(5*lineasProd.length)
              }
              if(heightLineaItem>heightDisponible){
                posic=35
                heightDisponible=heightDoc-25
              }
              if(lineasProd.length===1){
                if(lineasUni.length===1){
                  heightDisponible=heightDisponible-5
                }else{
                  heightDisponible=heightDisponible-(5*lineasUni.length)
                }            
              }else{
                heightDisponible=heightDisponible-(5*lineasProd.length)
              }
            }
          })
  

          // let parrafoProd = elemento1.descrProducto.split("\n")
          // let lineasProd = doc.splitTextToSize(parrafoProd, 100)
          // let heightLineaPr=0
          // let parrafoUni = elemento1.descrUnidad.split("\n")
          // let lineasUni = doc.splitTextToSize(parrafoProd, 40)
          // let parrafoLinea = []
          // let numeroLineas=0

          // if(lineasProd.length<lineasUni.length){
          //   parrafoLinea=parrafoUni
          //   numeroLineas=lineasUni.length
          // }else{
          //   parrafoLinea=parrafoProd
          //   numeroLineas=lineasProd.length
          // }
          //   parrafoLinea.forEach((textoProd, ii) => {   
          //     if(textoProd){
          //       if(numeroLineas===1){
          //         posic+=5
          //         heightLineaPr=5
          //       }else{
          //         posic+=4.6*numeroLineas
          //         heightLineaPr=(4.6*numeroLineas)
          //       }
          //       if(heightLineaPr>heightDisponible){
          //         posic=35
          //         heightDisponible=heightDoc-25
          //       }
          //       if(numeroLineas===1){
          //         heightDisponible=heightDisponible-5
          //       }else{
          //         heightDisponible=heightDisponible-(4.6*numeroLineas)
          //       }
          //     }
          //   })

          // argsUpd.push(elemento1.descrProducto)
          argsUpd.push(parrafoProd) 
          argsUpd.push(general.formatNum(elemento1.cantidadRecibida.toString()))
          argsUpd.push(elemento1.descrUnidad)
          if(elemento1.moneda==='Pesos'){
          argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1.valorUniCoti * (1 - (elemento1.porcDcto/100))))
          argsUpd.push(new Intl.NumberFormat('de-DE').format((elemento1.valorUniCoti * (1 - (elemento1.porcDcto/100))) * elemento1.cantidadRecibida))
          }else{
            argsUpd.push((elemento1.valorUniCoti * (1 - (elemento1.porcDcto/100))).toLocaleString("es-CO", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }))
            argsUpd.push(((elemento1.valorUniCoti * (1 - (elemento1.porcDcto/100))) * elemento1.cantidadRecibida).toLocaleString("es-CO", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }))
          }
          subTotal+=(elemento1.valorUniCoti * (1 - (elemento1.porcDcto/100))) * elemento1.cantidadRecibida
          if(elemento1.porcIVA>0){
            totalIVA+=Math.round(((elemento1.valorUniCoti * (1 - (elemento1.porcDcto/100))) * elemento1.cantidadRecibida) * (elemento1.porcIVA/100))
          }
          totalCoti=subTotal+totalIVA
          tablaCoti.push(argsUpd)
          argsUpd = []
        })

        argsUpd.push("")
        argsUpd.push("")
        argsUpd.push("")
        argsUpd.push("")
        argsUpd.push(subtot)
        argsUpd.push(new Intl.NumberFormat('de-DE').format(subTotal)) 
        tablaCoti.push(argsUpd)
        argsUpd = []
  
        argsUpd.push("")
        argsUpd.push("")
        argsUpd.push("")
        argsUpd.push("")
        argsUpd.push("IVA 19%")
        argsUpd.push(general.formatNum(parseInt(totalIVA).toString()))
        tablaCoti.push(argsUpd)
        argsUpd = []
  
        argsUpd.push("")
        argsUpd.push("")
        argsUpd.push("")
        argsUpd.push("")
        argsUpd.push(tot)
        // argsUpd.push(general.formatNum(parseInt(totalCoti).toString()))
        argsUpd.push(new Intl.NumberFormat('de-DE').format(totalCoti)) 
        tablaCoti.push(argsUpd)
        argsUpd = []
  
  
        let datosCoti = tablaCoti;      
        doc.autoTable(columnasCoti,datosCoti,{
          margin: { left: 20, top : 40},
          startY: 82,
          rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
          styles: {
            fontSize: 9,
            lineColor: "black",
            lineWidth: 0.1,
            valign: "center",
          },
          headStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            valign: "top",
            // cellPadding: 1,
            fontStyle: "bold",
            fontSize: 9
          },
          bodyStyles: {
            fillColor: "white",
            textColor: "black",
            halign: "center",
            valign: "top",
            cellPadding: 0.5,
            // minCellHeight: 1.8
          },
          columnStyles: {
            0: {cellWidth: 10},
            1: {cellWidth: 80.2},
            2: {cellWidth: 12},
            3: {cellWidth: 27},
            4: {cellWidth: 20},
            5: {cellWidth: 20}
          },
          didParseCell(data) {
            if((data.row.index === numLineas || data.row.index === numLineas+1 || data.row.index === numLineas+2) && data.section==='body'){
              if(data.column.index === 0){
                data.cell.colSpan = 4
                data.cell.rowSpan = 3
              }
            }
          }
        })

        posic+=20
        heightDisponible=heightDoc-25-posic

        if(heightDisponible<20){
          posic=45
          heightDisponible=heightDoc-25
          doc.addPage()
        }
  
        columnas = ["OBSERVACIONES"];
        datos = [
          [list1.observacionesOC] 
        ];
  
        doc.autoTable(columnas,datos,{
          margin: 20,
          startY: posic,
          styles: {
            fontSize: 9,
            lineColor: "black",
            lineWidth: 0.1,
            valign: "top",
          },
          headStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            valign: "top",
            fontStyle: "bold",
            fontSize: 9
          },
          bodyStyles: {
            fillColor: "white",
            textColor: "black",
            halign: "center",
            fontStyle: "bold",
            fontSize: 9
          },
          columnStyles: {
            0: {cellWidth: 171.1},
          }
        })

        posic+=30
        heightDisponible=heightDoc-25-posic

        if(heightDisponible<20){
          posic=45
          heightDisponible=heightDoc-25
          doc.addPage()
        }

        columnas = ["", "", "", ""];
        datos = [
          ["Elaborado por:", nomUsuario, "Autorizado por:", "Paola Wihiler"],
          ["Recibido por:", "", "Fecha:", fechaHoy]
        ];
  
        doc.autoTable(columnas,datos,{
          margin: 20,
          startY: heightDoc-44,
          rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
          styles: {
            fontSize: 9,
            lineColor: "black",
            lineWidth: 0.1,
            valign: "top",
          },
          headStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            valign: "top",
            cellPadding: 1,
            fontStyle: "bold",
            fontSize: 9
          },
          bodyStyles: {
            fillColor: "white",
            textColor: "black",
            halign: "center",
            cellPadding: 0.5,
            // minCellHeight: 1.8
          },
          columnStyles: {
            0: {cellWidth: 30},
            1: {cellWidth: 55},
            2: {cellWidth: 30},
            3: {cellWidth: 55}
          }
        })

        const pageCount = doc.internal.getNumberOfPages();
        // For each page, print the page number and the total pages
        for(var i = 1; i <= pageCount; i++) {
            // Go to page i
          doc.setPage(i);
  
  //ENCABEZADO DE PAGINA
  
          let dirSlcm = 'images/logos/LCMSAS.png'
          // let dirSlcm = 'C:\\slcm\\logos\\LCMSAS.png'
          // let dirSlcm = empresa.rutaLogo
          let imgSource = new Image();
          try{
            imgSource.src = dirSlcm;
            doc.convertStringToImageData(imgSource)
            doc.addImage(imgSource, 'PNG', 20, 12, 55, 17);
          }catch{
            console.log("Logo de LCM no existe")
          }

          doc.setFontSize(11);
          doc.setFontStyle('Normal');
          doc.setTextColor("black");

          doc.text("ORDEN DE COMPRA", widthDoc/1.5, 15, 'center')
          doc.text("F - OC - " + list1.numOrdenCompra, widthDoc/1.5, 20, 'center') 
          doc.text("EDICION: 01/02/2016", widthDoc/1.5, 25, 'center')   
          doc.text("VERSION: 01", widthDoc/1.5, 30, 'center') 
          doc.text("Página: 1", widthDoc/1.5, 35, 'center')    
  //FIN ENCABEZADO DE PAGINA
  
  //PIE DE PAGINA
          doc.setFontSize(8);
          doc.setTextColor(255,0,0);
          doc.setFontStyle('Watermark');
          doc.text(empresa.empresaWeb, widthDoc/1.7, heightDoc-24, 'center')
          doc.text("Dirección: " + empresa.empresaDir1, widthDoc/1.7, heightDoc-21, 'center') 
          doc.text(empresa.empresaCiudad1, widthDoc/1.7, heightDoc-18, 'center')   
          doc.text("Dirección: " + empresa.empresaDir2, widthDoc/1.7, heightDoc-15, 'center') 
          doc.text(empresa.empresaCiudad2, widthDoc/1.7, heightDoc-12, 'center')
  //FIN PIE DE PAGINA
        }
        
        let nameDoc = `ORDEN_DE_COMPRA_${list1.numOrdenCompra}.pdf`
        doc.save(nameDoc) 
  
        document.body.style.cursor = 'default'
      //FIN Exportar a Pdf
        this.setState({open: false, confirmaAct: false})
  
    // }else{
    //   alert("!! Por favor seleccione una orden de compra !!")
    // }
    this.setState({open: false, confirmaAct: false})
  }

  handleCerrar = async (ev, idListaP)=>{
    if(idListaP.numCoti){
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      let fechaRta = fechaHoraHoy
      let usuarioRta = localStorage.getItem('userLogin')
      
      let estadoOC = ''
      let posic = 0
      document.body.style.cursor = 'wait'
      estadoOC = 'Cerrada'

      const argsUpd = {
        numCoti: idListaP.numCoti,
        estadoOC: estadoOC,
        fechaEnvio: fechaRta,
        usuarioEnvio: usuarioRta,
        tipoAct: 'EditarRta3'
      }
      response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;

      if (!success){
        this.setState({errorAdd: errors})
      }else{
        this.props.allCotizacionRtes2.refetch()
        this.props.allCotizacionRtes.refetch()
        this.props.allCotizacionRtes1Proc.refetch()

        document.body.style.cursor = 'default'

        alert("!! Orden de compra cerrada !!")
      }

    }else{
      alert("!! Por favor seleccione una orden de compra !!")
    }
    this.setState({open: false, confirmaAct: false})
  }



  handleCantidad = async (idListaP, idListaI, cantidad)=>{
    if(idListaI.descrProducto){
      document.body.style.cursor = 'wait'
      let tipoAc=''
      if(idListaI.numProductoCoti && idListaI.numProductoCoti>0){
        tipoAc = 'EditarItem3ID'
      }else{
        tipoAc = 'EditarItem3'
      }
      const argsUpd = {
        numCoti: idListaP.numCoti,
        numSolic: idListaP.numSolic,
        cantidadRecibida: parseInt(cantidad),
        descrProducto: idListaI.descrProducto,
        numProductoCoti: idListaI.numProductoCoti?idListaI.numProductoCoti:0,
        tipoAct: 'EditarItem3'
      }
      console.log(argsUpd)
      const response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;

      if (!success){
        this.setState({errorAdd: errors})
      }else{
        let argsBuscar=""
        argsBuscar += `'numCoti': '${idListaP.numCoti}'`
        let argsBuscarIt = {}
        argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
        let {data} = await this.props.allCotizacionRtes1Proc.refetch(argsBuscarIt)
        this.setState({lista4: await data.allCotizacionRtes})
        this.setState({idListaI: idListaI})
    
        document.body.style.cursor = 'default'

        alert("!! Cantidad registrada !!")
      }
    }else{
      alert("!! Por favor seleccione un producto !!")
    }

  }

  handleReversar = async (ev, idListaP)=>{
    console.log(idListaP)
    if(idListaP.numSolic){
      document.body.style.cursor = 'wait'

      const argsUpd = {
        numCoti: idListaP.numSolic,
        estadoCoti: 'Creada',
        tipoAct: 'ReversarSolic'
      }

      let response = await this.props.editCotizacion({
        variables: argsUpd
      });
      const {errors, success} = response.data.editCotizacion;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        // let argsBuscar=""
        // argsBuscar += `'tipo': 'Cotización', 'numSolic': '${args.numSolic}'`
        let argsBuscarIt2 = {}
        argsBuscarIt2 = {tipoqry: `[{$match: {'tipo': 'Cotización', 'numSolic': '${idListaP.numSolic}'}},
        {$project: {_id: 1, numSolic: 1}}]`}
        console.log(argsBuscarIt2)
        let {data} = await this.props.allCotizacionRtes3.refetch(argsBuscarIt2)
        // console.log(this.props.allCotizacionRtes3.allCotizacionRtes)
        // let estructura = await data.allCotizacionRtes
console.log(data.allCotizacionRtes)
        if(data.allCotizacionRtes.length>0){
          for(let i=0; i<data.allCotizacionRtes.length; i++){
            console.log(data.allCotizacionRtes[i])
            const argsDel = {
              _id: data.allCotizacionRtes[i]._id
            }
            console.log(argsDel)
            await this.props.deleteCotizacion({
              variables: argsDel
            });
          }
        }
        this.state.lista=[]
        this.state.lista4=[]
        this.props.allCotizacionRtes2.refetch()
        document.body.style.cursor = 'default'

        alert("!! Estado reversado !!")
      }
    }else{
      alert("!! Por favor seleccione una solicitud !!")
    }
    this.setState({permiteBtn1: true, permiteBtn2: true, open: false, confirmaAct: false})
  }

  render(){
    const {idListaP, idListaI, permiteBtn1, permiteBtn2, confirmaAct, open, argsDocumI} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let list = [], list2 = [], list4 = []  
    this.props.allCotizacionRtes2.refetch()
    if(this.props.allCotizacionRtes2.allCotizacionRtes){list2 = this.props.allCotizacionRtes2.allCotizacionRtes}
    if(this.state.lista4){list4 = this.state.lista4}
    if(this.state.lista){list = this.state.lista}

    let mensaje1 = "Eliminar PDF enviado de OC "
    let mensajeAsImCoti = "Asociar PDF enviado de OC "
    let mensaje2 = "Eliminar PDF recibido de OC "
    let mensajeAsImCoti2 = "Asociar PDF recibido de OC "
    let mensaje7 = "REVERSAR " 
    if(idListaP.numCoti){
      mensaje1 += idListaP.numOrdenCompra
      mensajeAsImCoti += idListaP.numOrdenCompra
      mensaje2 += idListaP.numOrdenCompra
      mensajeAsImCoti2 += idListaP.numOrdenCompra
      mensaje7 += idListaP.numSolic
    }else{
      mensaje1 += "(Seleccionar...)"
      mensajeAsImCoti += "(Seleccionar...)"
      mensaje2 += "(Seleccionar...)"
      mensajeAsImCoti2 += "(Seleccionar...)"
    }
    let mensaje3 = "CERRAR"
    let mensaje4 = "PDF"  
    let mensaje5 = "MODIFICAR CANTIDAD"   
    let imgIcon1 = "images/archivo_32.png"


  return (
    <div>
      <List selection>
        <TitDer textBoton1="Ordenes de compra en proceso" btnNuevo={"NO"} styles={this.props.styles}/>
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?
            permiteBtn1?
              (ev)=>this.props.handleElimAsDocCoti(ev, idListaP, 'E')
              :permiteBtn2?
                (ev)=>this.props.handleElimAsDocCoti(ev, idListaP, 'R')
                :()=>{}                
            :()=>{}}
          > 
            <div className="ui four column stackable grid">
              <div className="column" style={{width: '60%', paddingLeft: '1.2em'}}>
                <Form.Field>
                  <ListaSol styles={this.props.styles} list={list2}
                    handleChange={this.handleChange} />
                </Form.Field>
              </div>
              {idListaP.numSolic &&
                <div className="column" style={{width: '20%'}}>
                  <Button id="reversar" name="reversar" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleReversar(ev, idListaP)} fluid>
                    {mensaje7}
                  </Button>                 
                </div>
              }
              <div className="column" style={{width: '10%'}}>
                {idListaP.numCoti && 
                  <Button id="pdf" name="pdf" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleImpPdf(ev, idListaP, this.props.nomUsuarioUA)} fluid>
                    {mensaje4}
                  </Button>                  
                }
              </div>
              <div className="column" style={{width: '10%'}}>
                {idListaP.numCoti && 
                  <Button id="cerrar" name="cerrar" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleCerrar(ev, idListaP)} fluid>
                    {mensaje3}
                  </Button>
                }
              </div>
            </div>
            <div style={{height: '10em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Fecha solic.</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Fecha OC</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}># Solicitud</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}># Cotización</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}># Orden compra</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Proveedor</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Valor sin IVA</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Valor con IVA</th>                    
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Archivo enviado</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '50%'}}>Archivo recibido</th>
                  </tr>
                </thead>
                <ListaPl list={list} handleClickidLista={this.handleClickidLista} idListaP={idListaP}/>
              </table>
              <p></p>
            </div>
            <div className="ui four column stackable grid">
              {idListaP.numCoti && !idListaP.archivoEnviado &&
                <div className="column" style={{width: '25%', paddingTop: '2.5em'}}>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                      {mensajeAsImCoti}
                    </label>
                  
                </div>
              }
              {idListaP.numCoti && idListaP.archivoEnviado &&
                <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                      
                    </label>
                  
                </div>
              }
              <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                    
                  </label>
              </div>
              {idListaP.numCoti && idListaP.archivoRecibido &&
                <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                      
                    </label>
                  
                </div>
              }
              {idListaP.numCoti && !idListaP.archivoRecibido &&
                <div className="column" style={{width: '25%', paddingTop: '2.5em'}}>
                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                      {mensajeAsImCoti2}
                    </label>
                  
                </div>
              }
              <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                    
                  </label>
              </div>
            </div>

            <div className="ui four column stackable grid">
                {idListaP.numCoti && idListaP.archivoEnviado &&
                  <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                        
                      </label>
                    
                  </div>
                }
                {idListaP.numCoti && !idListaP.archivoEnviado &&
                  <div className="column" style={{width: '25%', paddingLeft: '1.2em'}}>
                      <Form.Field>
                        <input id="img1" name="img1" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={(ev)=>this.props.handleUpdAsDocCoti(ev, idListaP, 'E')}></input>
                      </Form.Field>
                    
                  </div>
                }
                {idListaP.numCoti && idListaP.archivoEnviado &&
                  <div className="column" style={{width: '25%', paddingTop: '0.3em'}}>
                    <EstaSeg7Btn mensaje1={mensaje1} imgIcon1={imgIcon1} 
                      open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>
                  </div>
                } 
                {idListaP.numCoti && !idListaP.archivoEnviado &&
                  <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                        
                      </label>
                  </div>
                }
                {idListaP.numCoti && idListaP.archivoRecibido &&
                  <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                        
                      </label>
                  </div>
                }
                {idListaP.numCoti && !idListaP.archivoRecibido &&
                  <div className="column" style={{width: '25%', paddingLeft: '1.2em'}}>
                      <Form.Field>
                        <input id="img2" name="img2" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={(ev)=>this.props.handleUpdAsDocCoti(ev, idListaP, 'R')}></input>
                      </Form.Field>
                  </div>
                }
                {idListaP.numCoti && idListaP.archivoRecibido &&
                  <div className="column" style={{width: '25%', paddingTop: '0.3em'}}>
                    <EstaSeg7Btn mensaje2={mensaje2} imgIcon1={imgIcon1} open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "2")}/>
                  </div>
                }    
                {idListaP.numCoti && !idListaP.archivoRecibido &&
                  <div className="column" style={{width: '25%', paddingTop: '0em'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0em 0em 0em 0em'}}>
                        
                      </label>
                  </div>
                }
            </div>
            <div style={{height: '15em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Cant. coti</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Cant. aprob</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Cant. recibida</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Unidad</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '27%'}}>Producto</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Valor unidad</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>% Descuento</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Total producto</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>% IVA</th>
                  </tr>
                </thead>
                <Lista listI={list4} handleClickidListaI={this.handleClickidListaI} idListaI={idListaI}/>
              </table> 
              <p></p>
            </div>
            <div className="ui three column stackable grid">
              <div className="column" style={{width: '10%', paddingTop: '2.2em'}}>
                {idListaI.descrProducto && 
                  <Form.Field>
                    <label style={this.props.styles.label}>Cant. recibida de {idListaI.descrProducto}:</label>
                  </Form.Field>                
                }
              </div>
              <div className="column" style={{width: '10%', paddingTop: '1.9em'}}>
                {idListaI.descrProducto && 
                  <Form.Field>
                    <Form.Input type='number' step="0.1" min="0.1" autoComplete="off" name="cantidadRecibida" id="cantidadAprob" value={argsDocumI.cantidadAprob} onChange={(ev)=>this.handleChangeI(ev, idListaP.numCoti, idListaI.descrProducto)} placeholder='cantidad'/>
                  </Form.Field>                
                }
              </div>
              <div className="column" style={{width: '30%', paddingTop: '1.9em'}}>
                {idListaI.descrProducto && 
                  <Button id="canti" name="canti" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleCantidad(idListaP, idListaI, argsDocumI.cantidadRecibida)} fluid>
                    {mensaje5}
                  </Button>                  
                }
              </div>
            </div>
          </Form>
        </div>
      </List>
    </div>
  )
  }
};

export default compose( 
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', estadoOC: 'Creada'}}, {$sort: {numOrdenCompra: -1}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes3',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor'}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', estadoOC: 'xxx'}}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes1Proc',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', estadoOC: 'xxx'}}]`}}}}),

  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),
  graphql(queries.mutation.deleteCotizacion, {name:'deleteCotizacion'}),
  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(AdminOrdenCompraPro2)
